'use client';

import {
  clearScrollRestore,
  LAST_DETAIL_PATH_KEY,
} from '@/hooks/use-scroll-restoration';
import { useEffect } from 'react';

/**
 * 하드웨어 백(안드로이드 등) 시 상세 페이지를 나가면
 * 해당 pathname의 스크롤·펼침 상태를 clear 하기 위한 popstate 리스너.
 * academy 레이아웃에서 한 번만 마운트됨.
 */
export default function ScrollRestorePopstateListener() {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const onPopState = () => {
      try {
        const currentPath = window.location.pathname;
        const lastDetailPath = sessionStorage.getItem(LAST_DETAIL_PATH_KEY);
        if (lastDetailPath && currentPath !== lastDetailPath) {
          clearScrollRestore(lastDetailPath);
          sessionStorage.removeItem(LAST_DETAIL_PATH_KEY);
        }
      } catch {
        // ignore
      }
    };

    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  return null;
}
